export const SET_FORM = "TELLMEWHENARRIVE/SET_FORM";
export const SET_RESET_MODAL = "TELLMEWHENARRIVE/SET_RESET_MODAL";
export const SET_PRODUCT = "TELLMEWHENARRIVE/SET_PRODUCT";
